var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.23 52.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "expenses2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.12,0A26.12,26.12,0,1,0,52.23,26.12,26.11,26.11,0,0,0,26.12,0Zm0,50.14a24,24,0,1,1,24-24A24,24,0,0,1,26.12,50.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.47,26.59a10.05,10.05,0,0,0-2.57-1.17,6.48,6.48,0,0,1-2.36-1.19,2.24,2.24,0,0,1-.72-1.75,2.48,2.48,0,0,1,.68-1.85,2.66,2.66,0,0,1,2-.67,2.4,2.4,0,0,1,2,.9,3.75,3.75,0,0,1,.72,2.42h2a5.43,5.43,0,0,0-1-3.49,4.12,4.12,0,0,0-2.82-1.52V15.9h-1.6v2.36a4.35,4.35,0,0,0-2.84,1.35,4.16,4.16,0,0,0-1,2.9,4,4,0,0,0,1.05,2.86,7.42,7.42,0,0,0,3.36,1.83,6.25,6.25,0,0,1,2.34,1.23,2.24,2.24,0,0,1,.7,1.68A2.28,2.28,0,0,1,28.46,32a3.31,3.31,0,0,1-2.22.68A3,3,0,0,1,24,31.83a3.2,3.2,0,0,1-.79-2.31h-2a4.83,4.83,0,0,0,1.14,3.39,4.68,4.68,0,0,0,3.14,1.43V36.4h1.6V34.34A4.87,4.87,0,0,0,30.17,33a4,4,0,0,0,1.09-2.94,4.32,4.32,0,0,0-.43-2A4.18,4.18,0,0,0,29.47,26.59Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.5a2eba28.svg";
export { ForwardRef as ReactComponent };